/**
 * Moving to gatsby es-build mode will enable imports & resolve this duplication
 */

const RESOURCE_LIBRARY_PATHNAME = "resource-library";
const BLOG_PATHNAME = "blog";
const NEWS_PATHNAME = "news";
const GATED_SUCCESS_PATHNAME = "thank-you";
const TYPE_MICRO_ASSET = "ContentfulMicroAsset";

module.exports = {
    RESOURCE_LIBRARY_PATHNAME,
    BLOG_PATHNAME,
    NEWS_PATHNAME,
    GATED_SUCCESS_PATHNAME,
    TYPE_MICRO_ASSET,
};
